export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Krypto-ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprache"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guten Morgen"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guten Tag"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guten Abend"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gute Nacht"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abmelden"])}
}